export default __webpack_public_path__ + "assets/images/40a18d265444876aaa0e2f9e38cac2ab.png";